import { FormControl, RadioToggle, RadioToggleGroup } from '@mezzoforte/forge';
import { ReceiptChoice, ReceiptType } from '@/types/ListEntry';

export interface ReceiptTypeSelectionProps {
  receiptTypes: ReceiptChoice[];
  selectedReceiptType: ReceiptType | null;
  onChange: (type: ReceiptType) => void;
}

export default function ReceiptTypeSelection({
  receiptTypes,
  selectedReceiptType,
  onChange,
}: ReceiptTypeSelectionProps) {
  if (!receiptTypes.length) return null;
  return (
    <FormControl>
      <RadioToggleGroup
        defaultValue={selectedReceiptType?.toString()}
        label="Tarjoan"
        data-test="receipt-select"
      >
        {receiptTypes.map((type) => (
          <RadioToggle
            key={type.type}
            value={type.type.toString()}
            onChange={(e) => {
              if (e.currentTarget.checked) onChange(type.type);
            }}
          >
            {type.label}
          </RadioToggle>
        ))}
      </RadioToggleGroup>
    </FormControl>
  );
}
